import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_INBOUND_CALL = "GET_LIST_INBOUND_CALL";
export const GET_LIST_INBOUND_CALL_ERROR = "GET_LIST_INBOUND_CALL_ERROR";
export const GET_LIST_INBOUND_CALL_SUCCESS = "GET_LIST_INBOUND_CALL_SUCCESS";

export const GET_LIST_AGENT_INBOUND_CALL = "GET_LIST_AGENT_INBOUND_CALL";
export const GET_LIST_AGENT_INBOUND_CALL_ERROR =
  "GET_LIST_AGENT_INBOUND_CALL_ERROR";
export const GET_LIST_AGENT_INBOUND_CALL_SUCCESS =
  "GET_LIST_AGENT_INBOUND_CALL_SUCCESS";

export const COUNT_NUMBER_INBOUND_CALL = "COUNT_NUMBER_INBOUND_CALL";
export const COUNT_NUMBER_INBOUND_CALL_ERROR =
  "COUNT_NUMBER_INBOUND_CALL_ERROR";
export const COUNT_NUMBER_INBOUND_CALL_SUCCESS =
  "COUNT_NUMBER_INBOUND_CALL_SUCCESS";

/**
 * Reducer
 */

const initialState = {
  inbound: [],
  error: false,
  count: 0,
  loading: false,
};

export const inboundReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_INBOUND_CALL:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_INBOUND_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        inbound: action.payload,
      };
    case GET_LIST_INBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    case GET_LIST_AGENT_INBOUND_CALL:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_AGENT_INBOUND_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        inbound: action.payload,
      };
    case GET_LIST_AGENT_INBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_NUMBER_INBOUND_CALL:
      return {
        ...state,
      };
    case COUNT_NUMBER_INBOUND_CALL_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_NUMBER_INBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getList = (order, limit, skip, where, contactCode) => ({
  type: GET_LIST_INBOUND_CALL,
  data: {
    order,
    limit,
    skip,
    where,
    contactCode,
  },
});

export const getInboundCallAgent = (
  agentGroupId,
  order,
  limit,
  skip,
  where,
  contactCode
) => ({
  type: GET_LIST_AGENT_INBOUND_CALL,
  data: {
    agentGroupId,
    order,
    limit,
    skip,
    where,
    contactCode,
  },
});

export const countInboundCall = (where, contactCode) => ({
  type: COUNT_NUMBER_INBOUND_CALL,
  data: {
    where,
    contactCode,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getList,
      countInboundCall,
      getInboundCallAgent,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListApi = (order, limit, skip, where, contactCode) => {
  const queryContact = contactCode ? `contactCode=${contactCode}` : "";
  return apiCaller.getLogs(`/cloud-pbx/inbound-call?${queryContact}`, {
    order,
    limit,
    skip,
    ...where,
  });
};

const getInboundCallAgentApi = (
  agentGroupId,
  order,
  limit,
  skip,
  where,
  query,
  contactCode
) => {
  const queryContact = contactCode ? `contactCode=${contactCode}` : "";
  return apiCaller.getLogs(
    `/cloud-pbx/inbound-call?agentGroupId=${agentGroupId}&${queryContact}`,
    { order, limit, skip, ...where, query }
  );
};

const countInboundCallApi = (where, contactCode) => {
  const queryContact = contactCode ? `?contactCode=${contactCode}` : "";
  return apiCaller.getData(`/cloud-pbx/inbound-call/count${queryContact}`, {
    ...where,
  });
};

/**
 * sagas
 */

export const getListInboundCallFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_INBOUND_CALL);
    try {
      const res = yield call(
        getListApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.contactCode
      );
      const data = res.data.sort(function (a, b) {
        return (
          new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime()
        );
      });
      yield put({ type: GET_LIST_INBOUND_CALL_SUCCESS, payload: { ...data } });
    } catch (error) {
      yield put({ type: GET_LIST_INBOUND_CALL_ERROR, error });
    }
  }
};

export const getInboundCallAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_AGENT_INBOUND_CALL);
    try {
      const res = yield call(
        getInboundCallAgentApi,
        action.data.agentGroupId,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.contactCode
      );
      yield put({
        type: GET_LIST_AGENT_INBOUND_CALL_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_AGENT_INBOUND_CALL_ERROR, error });
    }
  }
};

export const countInboundCallFlow = function* () {
  while (true) {
    const action = yield take(COUNT_NUMBER_INBOUND_CALL);
    try {
      const res = yield call(
        countInboundCallApi,
        action.data.where,
        action.data.contactCode
      );
      yield put({
        type: COUNT_NUMBER_INBOUND_CALL_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_NUMBER_INBOUND_CALL_ERROR, error });
    }
  }
};

export const exportInbound = async (where, contactCode = null) => {
  const queryContact = contactCode ? `&contactCode=${contactCode}` : "";
  return await apiCaller.getLogs(
    `/cloud-pbx/inbound-call?query=export${queryContact}`,
    { ...where }
  );
};
